export const API_URL = `https://api.weekday.technology/adhoc/getSampleJdJSON`
